module.exports = __webpack_public_path__ + "img/service_devops_2_mob.e6d0de68.jpg";